import _defineProperty from "/Users/martin/DEV/DFN_VEOMED-dfn/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
// src/components/alert.ts
import { alertAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar } from "@chakra-ui/styled-system";
import { transparentize } from "@chakra-ui/theme-tools";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  definePartsStyle = _createMultiStyleConf.definePartsStyle,
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;
var $fg = cssVar("alert-fg");
var $bg = cssVar("alert-bg");
var baseStyle = definePartsStyle({
  container: {
    bg: $bg.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: $fg.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: $fg.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
});
function getBg(props) {
  var theme = props.theme,
    c = props.colorScheme;
  var darkBg = transparentize("".concat(c, ".200"), 0.16)(theme);
  return {
    light: "colors.".concat(c, ".100"),
    dark: darkBg
  };
}
var variantSubtle = definePartsStyle(function (props) {
  var _dark, _container;
  var c = props.colorScheme;
  var bg = getBg(props);
  return {
    container: (_container = {}, _defineProperty(_container, $fg.variable, "colors.".concat(c, ".500")), _defineProperty(_container, $bg.variable, bg.light), _defineProperty(_container, "_dark", (_dark = {}, _defineProperty(_dark, $fg.variable, "colors.".concat(c, ".200")), _defineProperty(_dark, $bg.variable, bg.dark), _dark)), _container)
  };
});
var variantLeftAccent = definePartsStyle(function (props) {
  var _dark2, _container2;
  var c = props.colorScheme;
  var bg = getBg(props);
  return {
    container: (_container2 = {}, _defineProperty(_container2, $fg.variable, "colors.".concat(c, ".500")), _defineProperty(_container2, $bg.variable, bg.light), _defineProperty(_container2, "_dark", (_dark2 = {}, _defineProperty(_dark2, $fg.variable, "colors.".concat(c, ".200")), _defineProperty(_dark2, $bg.variable, bg.dark), _dark2)), _defineProperty(_container2, "paddingStart", "3"), _defineProperty(_container2, "borderStartWidth", "4px"), _defineProperty(_container2, "borderStartColor", $fg.reference), _container2)
  };
});
var variantTopAccent = definePartsStyle(function (props) {
  var _dark3, _container3;
  var c = props.colorScheme;
  var bg = getBg(props);
  return {
    container: (_container3 = {}, _defineProperty(_container3, $fg.variable, "colors.".concat(c, ".500")), _defineProperty(_container3, $bg.variable, bg.light), _defineProperty(_container3, "_dark", (_dark3 = {}, _defineProperty(_dark3, $fg.variable, "colors.".concat(c, ".200")), _defineProperty(_dark3, $bg.variable, bg.dark), _dark3)), _defineProperty(_container3, "pt", "2"), _defineProperty(_container3, "borderTopWidth", "4px"), _defineProperty(_container3, "borderTopColor", $fg.reference), _container3)
  };
});
var variantSolid = definePartsStyle(function (props) {
  var _dark4, _container4;
  var c = props.colorScheme;
  return {
    container: (_container4 = {}, _defineProperty(_container4, $fg.variable, "colors.white"), _defineProperty(_container4, $bg.variable, "colors.".concat(c, ".500")), _defineProperty(_container4, "_dark", (_dark4 = {}, _defineProperty(_dark4, $fg.variable, "colors.gray.900"), _defineProperty(_dark4, $bg.variable, "colors.".concat(c, ".200")), _dark4)), _defineProperty(_container4, "color", $fg.reference), _container4)
  };
});
var variants = {
  subtle: variantSubtle,
  "left-accent": variantLeftAccent,
  "top-accent": variantTopAccent,
  solid: variantSolid
};
var alertTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  variants: variants,
  defaultProps: {
    variant: "subtle",
    colorScheme: "blue"
  }
});
export { alertTheme };